import { Grid } from '@material-ui/core';
import { useScrollButtonState } from '@ncr-retail/hooks';
import React from 'react';
import { styles } from './force-exchange-component-styles';
import { ForcedExchangeNavButtons } from './force-exchange-nav-buttons';
import { useTranslation } from 'react-i18next';
import ExchangeListItem from './exchange-list-item';

export interface ForcedExchangeQuantity {
  value: number;
  entryMethod: string;
}

export interface ForcedExchangeAmount {
  amount: number;
  currency: string;
}

export interface ForcedExchangeLines {
  description: string;
  extendedAmount: ForcedExchangeAmount;
  itemId: string;
  quantity: ForcedExchangeQuantity;
  managerOverride?: boolean;
  lineSequence: string;
}

export interface ForcedExchangeTransaction {
  managerOverride?: boolean;
  minAmount?: number;
}

export interface ForcedExchangeListProp {
  forcedExchangeLines: ForcedExchangeLines[];
  handleSelection: ((index: number) => void) | (() => void);
  selectedLines: number[];
  transaction: ForcedExchangeTransaction;
  thresholdOverride: boolean;
  thresholdSelected?: boolean;
  hasExchangeLines: boolean;
}

const ForcedExchangeList: React.FC<ForcedExchangeListProp> = ({
  forcedExchangeLines,
  selectedLines,
  handleSelection,
  transaction,
  thresholdOverride,
  thresholdSelected,
  hasExchangeLines,
}): JSX.Element => {
  const classes = styles();
  const transactionAmount = transaction?.minAmount;
  const { t } = useTranslation();
  const [
    { navScrollUpEnabled, navScrollDownEnabled, onClickNavButtonUp, onClickNavButtonDown },
    scrollRef,
  ] = useScrollButtonState(forcedExchangeLines.length, false);
  return (
    <Grid container className={`${classes.listContainer}`} direction='column'>
      <Grid item container className={`fullWidth ${classes.scrollContainer}`}>
        <div ref={scrollRef} className='verticalScroll fullWidth fullHeight'>
          <Grid container className={`${classes.resultsContainer}`}>
            {hasExchangeLines ? (
              forcedExchangeLines.map((line, index) => {
                const { description, extendedAmount, itemId, quantity, managerOverride } = line;
                const amount = extendedAmount.amount;
                const qtyValue = quantity.value;

                return (
                  <ExchangeListItem
                    key={`${itemId}-${index}`}
                    handleSelection={handleSelection}
                    managerOverride={managerOverride || false}
                    thresholdOverride={thresholdOverride}
                    amount={amount}
                    index={index}
                    description={description}
                    itemId={itemId}
                    quantity={qtyValue}
                    selectedLines={selectedLines}
                  />
                );
              })
            ) : (
              <ExchangeListItem
                handleSelection={handleSelection}
                managerOverride={false}
                thresholdOverride={thresholdOverride}
                amount={transactionAmount}
                index={-1}
                description={t('ForcedExchangeView_ReturnThreshold')}
                thresholdSelected={thresholdSelected}
              />
            )}
          </Grid>
        </div>
      </Grid>
      <Grid item className={`fullWidth ${classes.exchangeNavButtonContainer}`}>
        <ForcedExchangeNavButtons
          onClickNavButtonDown={onClickNavButtonDown}
          onClickNavButtonUp={onClickNavButtonUp}
          navScrollDownEnabled={navScrollDownEnabled}
          navScrollUpEnabled={navScrollUpEnabled}
        />
      </Grid>
    </Grid>
  );
};

export default ForcedExchangeList;
